// @ts-nocheck
import React, {
  useContext,
  useState,
  useCallback,
  useRef,
  useEffect
} from 'react';
import {
  AppContext,
  useStateCallback,
  AppLoader,
  getBrowserType
} from '@nile/components';
import styled from 'styled-components';
import HomePage from '@nile/mangifera/src/Pages/HomePage';
import ModulesPage from '@nile/mangifera/src/Pages/ModulesPage';
import GlobalCreatePage from '@nile/mangifera/src/Pages/GlobalCreatePage';
import SettingsPage from '@nile/mangifera/src/Pages/SettingsPage';
import SpotlightPage from '@nile/mangifera/src/Pages/SpotlightPage';
import { HomeProvider } from '@nile/mangifera/src/Contexts/HomeContext';
import TabManager from '@nile/mangifera/src/Containers/TabManager';
import { withRouter } from 'react-router-dom';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import {
  SAVE_PERSONALIZATION,
  AccountClient,
  GET_PERSONALIZATION_BY_NAME,
  savePersonalization,
  getPersonalization,
  GET_CUSTOMER_PAYMENT_STATUS
} from '@nile/graphql';
import { cloneDeep, isEqual, pick } from 'lodash';
import {
  getTabId,
  getTabUrl,
  getTabDisplayData,
  getTabContent,
  getTabTemplate,
  getTabUrlNew
} from '@nile/mangifera/src/Pebbles/TabManager';
import { Frame } from '@shopify/polaris';
import envConfig from '@nile/home/src/Config/env';
import AppNavigation from '@nile/components/src/Navigations/AppNavigation';
import { useFlags, withLDConsumer } from 'launchdarkly-react-client-sdk';
import { isFeatureAvailable } from '@nile/components/src/HOC/withPlanFeatureGating';
import { getTabPersonalisationCategory } from '@nile/components/src/Utils/helpers';
import { useLocation } from 'react-router-dom';

function AppHomePage(props) {
  const appContext = useContext(AppContext);
  const [homeOverlay, setHomeOverlay] = useState(false);
  const [modulesOverlay, setModulesOverlay] = useState(false);
  const [createNewOverlay, setCreateNewOverlay] = useState(false);
  const [settingsOverlay, setSettingsOverlay] = useState(false);
  const [spotlightOverlay, setSpotlightOverlay] = useState(false);
  const [userAppState, setUserAppState] = useStateCallback(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [showQrMessage, setShowQrMessage] = useState(false);
  const { currentServicePortal, currentProduct } = appContext;
  const currentUser = appContext?.user;
  const [records, setRecords] = useState([]);
  const [viewConditions, setViewConditions] = useStateCallback(null);
  const [customerPaymentDetail, setCustomerPaymentDetail] = useState(false);
  const location = useLocation();

  const [ticketOrProjectToInvoice, setTicketOrProjectToInvoice] = useState(
    null
  );
  const [productsToInvoice, setProductsToInvoice] = useState(null);
  const isTicketing = isFeatureAvailable(
    appContext?.planFeatureList,
    'TICKETING'
  );

  const [getCustomerDetail] = useLazyQuery(GET_CUSTOMER_PAYMENT_STATUS, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    onCompleted: (res) => {
      if (res?.getCustomerDetail) {
        setCustomerPaymentDetail(res?.getCustomerDetail?.checkoutProgressState);
      }
    }
  });

  const getItemsToInvoice = useCallback(
    (type, items) => {
      let allProducts = productsToInvoice || {};
      const itemsToInvoice = items?.length ? items : null;
      if (type === 'PRODUCTS') {
        allProducts = { ...allProducts, products: itemsToInvoice };
        setProductsToInvoice(allProducts);
      } else if (type === 'WORKLOGS') {
        allProducts = { ...allProducts, worklogs: itemsToInvoice };
        setProductsToInvoice(allProducts);
      }
    },
    [productsToInvoice]
  );
  const tabRef = useRef({});

  const setViewConditionsCb = (c, cb) => {
    setViewConditions(c, cb);
  };

  const closeModulesOverlay = (isCloseBtn) => {
    if (isCloseBtn) setSelectedModule(null);
    setModulesOverlay(false);
  };
  const closeHomeOverlay = (isCloseBtn) => {
    if (isCloseBtn) setSelectedModule(null);
    setHomeOverlay(false);
  };
  const closeCreateNewOverlay = (isCloseBtn) => {
    if (isCloseBtn) setSelectedModule(null);
    setCreateNewOverlay(false);
  };
  const closeSettingsOverlay = (isCloseBtn) => {
    if (isCloseBtn) setSelectedModule(null);
    setSettingsOverlay(false);
  };
  const closeSpotlightOverlay = (isCloseBtn) => {
    if (isCloseBtn) setSelectedModule(null);
    setSpotlightOverlay(false);
  };

  const toggleHomeOverlay = useCallback(() => {
    closeModulesOverlay();
    closeCreateNewOverlay();
    closeSettingsOverlay();
    setHomeOverlay(!homeOverlay);
    if (homeOverlay) setSelectedModule(null);
  });
  const toggleModulesOverlay = useCallback(() => {
    closeHomeOverlay();
    closeCreateNewOverlay();
    closeSettingsOverlay();
    setModulesOverlay(!modulesOverlay);
    if (modulesOverlay) setSelectedModule(null);
  });
  const toggleCreateNewOverlay = useCallback(() => {
    closeModulesOverlay();
    closeHomeOverlay();
    closeSettingsOverlay();
    setCreateNewOverlay(!createNewOverlay);
    if (createNewOverlay) setSelectedModule(null);
  });
  const toggleSettingsOverlay = useCallback(() => {
    closeModulesOverlay();
    closeHomeOverlay();
    closeCreateNewOverlay();
    closeSpotlightOverlay();
    setSettingsOverlay(!settingsOverlay);
    if (settingsOverlay) setSelectedModule(null);
  });
  const toggleSpotlightOverlay = useCallback(() => {
    closeModulesOverlay();
    closeHomeOverlay();
    closeCreateNewOverlay();
    setSpotlightOverlay(!spotlightOverlay);
    if (spotlightOverlay) setSelectedModule(null);
  });

  const escFunction = useCallback((event) => {
    if (event.code === 'KeyK' && event.ctrlKey) {
      event.preventDefault();
      setSpotlightOverlay(true);
    }

    if (event.code === 'KeyK' && event.metaKey) {
      setSpotlightOverlay(true);
    }
    if (event.key === 'Escape') {
      setSpotlightOverlay(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  useEffect(() => {
    // We can remove this function with Malathi's personalisation fixes
    getIntialViewState();
    getCustomerDetail();
    if (currentUser?.subscriptionStatus === 'TRIAL_EXPIRED') {
      const tab = {
        id: 'productonboard-tab',
        content: getTabTemplate({ module: 'PRODUCTONBOARD' }),
        accessibilityLabel: 'Onboarding',
        module: 'PRODUCTONBOARD',
        tabId: 'productonboard-tab',
        state: {},
        data: {},
        url: '/productonboard'
      };
      setUserAppState({
        appState: [tab],
        activeTabIndex: 0
      });
    }
  }, []);

  const {
    loading: userAppStateLoading,
    error: userAppStateError,
    data: peronalizedData
    // } = {};
  } = useQuery(GET_PERSONALIZATION_BY_NAME, {
    variables: {
      userId: currentUser?.userId,
      name: 'tabPersonalization',
      category: getTabPersonalisationCategory(
        currentServicePortal,
        currentProduct
      )
    },
    skip: currentUser?.subscriptionStatus === 'TRIAL_EXPIRED',
    // fetchPolicy: 'cache-and-network', // TODO find the actual reason for the component to be mounted again and fix this
    client: AccountClient,
    onCompleted(res) {
      if (res?.getPersonalizationByCategoryAndName?.value) {
        var tabPesonalisationRes = JSON.parse(
          res?.getPersonalizationByCategoryAndName?.value
        );
        if (!isTicketing) {
          tabPesonalisationRes.appState = tabPesonalisationRes.appState.filter(
            (item) => item.id !== 'workspace'
          );
        }
        if (tabPesonalisationRes.appState.length === 0) {
          tabPesonalisationRes.appState.push({
            id: 'home-tab',
            content: '',
            module: 'HOME',
            tabId: 'home-tab',
            state: {},
            data: {},
            url: '/home'
          });
        }
        setUserAppState({ ...tabPesonalisationRes });
      } else {
        const tab = isTicketing
          ? {
              id: 'workspace',
              content: getTabTemplate({ module: 'WORKSPACE' }),
              accessibilityLabel: 'My workspace',
              module: 'WORKSPACE',
              tabId: 8,
              state: {},
              data: {},
              url: '/ticket/1/ticket-list'
            }
          : {
              id: 'home-tab',
              content: '',
              module: 'HOME',
              tabId: 'home-tab',
              state: {},
              data: {},
              url: '/home'
            };
        if (currentUser?.role?.roleId === '1') {
          const onboardtab = {
            id: 'productonboard-tab',
            content: getTabTemplate({ module: 'PRODUCTONBOARD' }),
            accessibilityLabel: 'Onboarding',
            module: 'PRODUCTONBOARD',
            tabId: 'productonboard-tab',
            state: {},
            data: {},
            url: '/productonboard'
          };
          setUserAppState({
            appState: [tab, onboardtab],
            activeTabIndex: 1
          });
        } else {
          setUserAppState({
            appState: [tab],
            activeTabIndex: 0
          });
        }
      }
    },
    onError(err) {
      console.log(err, 'Error');
    }
  });

  /** *********************************************************
   * TEMPORARY TO MAKE THINGS WORK AS EXISTING.
   * SHOULD SEPARATE AS TAB CONTEXT AND MODULE SPECIFIC CONTEXT
   ********************************************************** */

  const [activeView, setActiveView] = useState(null);
  const [previousView, setPreviousView] = useState(null);
  const [personalization, setPersonalization] = useState('');
  const [viewType, setViewType] = useState('');
  const [viewTypeLoading, setViewTypeLoading] = useState(true);
  const [activeKanbanTab, setActiveKanbanTab] = useState('technician');
  const [taskViewType, setTaskViewType] = useState('list');
  const [projectViewType, setProjectViewType] = useState('list');
  const flags = useFlags();

  /**
   * USER PERSONALIZTION
   */

  const [tabPersonalization] = useMutation(SAVE_PERSONALIZATION, {
    client: AccountClient,
    update(cache, { data }) {
      if (flags?.updateTabsCache && data) {
        const tabPersonalizationCache = cache.readQuery({
          query: GET_PERSONALIZATION_BY_NAME,
          client: AccountClient,
          variables: {
            userId: currentUser?.userId,
            name: 'tabPersonalization',
            category: getTabPersonalisationCategory(
              currentServicePortal,
              currentProduct
            )
          }
        });
        const tabPersonalizationCacheClone = cloneDeep(
          tabPersonalizationCache?.getPersonalizationByCategoryAndName
        );
        const { tabs, selected } = tabRef?.current?.getCurrentState();
        tabPersonalizationCacheClone.value = JSON.stringify({
          appState: tabs.map((el) => {
            return pick(
              el,
              'data',
              'id',
              'module',
              'tabId',
              'url',
              'displayData',
              'ticketId',
              'scriptId',
              'lastAccessedAt'
            );
          }),
          activeTabIndex: selected
        });
        cache.writeQuery({
          query: GET_PERSONALIZATION_BY_NAME,
          variables: {
            userId: currentUser?.userId,
            name: 'tabPersonalization',
            category: getTabPersonalisationCategory(
              currentServicePortal,
              currentProduct
            )
          },
          data: {
            getPersonalizationByCategoryAndName: tabPersonalizationCacheClone
          }
        });
      }
    },
    onCompleted({ savePersonalization }) {
      if (savePersonalization) {
        // eslint-disable-line
      }
    },
    onError() {
      // toast('error', 'Something went wrong');
    }
  });

  const saveViewState = (type, category) => {
    const viewId = props.match?.params?.id || '1'; // "1" is added for ticket view ALL ticket
    const personalisedData = {
      name: activeView?.id || viewId,
      category: category,
      value: JSON.stringify({ viewType: type }),
      user: {
        firstName: currentUser?.firstName,
        userId: currentUser?.userId,
        email: currentUser?.email,
        lastName: currentUser?.lastName
      }
    };

    savePersonalization({
      variables: personalisedData,
      input: personalisedData
    }).then((res) => {
      if (res) {
        getPersonalization({
          name: activeView?.id || viewId,
          category: category,
          userId: currentUser?.userId
        });
      }
    });
  };

  const setViewTypeChange = (type) => {
    setViewType(type);
    saveViewState(type, 'TicketViewStatePersonalization');
  };

  const setTaskViewTypeChange = (type) => {
    setTaskViewType(type);
    saveViewState(type, 'TaskViewStatePersonalization');
  };

  const setProjectViewTypeChange = (type) => {
    setProjectViewType(type);
    saveViewState(type, 'ProjectViewStatePersonalization');
  };

  const getViewType = (viewId, category) => {
    const activeViewId = props.match?.params?.id || '1';
    return AccountClient.query({
      query: GET_PERSONALIZATION_BY_NAME,
      variables: {
        userId: currentUser?.userId,
        name: viewId || activeViewId,
        category: category
      }
    });
  };

  const getViewModule = (viewData) => {
    switch (viewData.id) {
      case '3':
      case '4':
      case '14':
        return 'TASK';
      default:
        return 'TICKET';
    }
  };

  const activeModuleDataMap = {
    TICKET: {
      category: 'TicketViewStatePersonalization',
      setState: setViewType
    },
    TASK: {
      category: 'TaskViewStatePersonalization',
      setState: setTaskViewType
    },
    PROJECT: {
      category: 'ProjectViewStatePersonalization',
      setState: setProjectViewType
    }
  };

  const handleActiveViewChange = (viewData) => {
    if (!isEqual(activeView, viewData)) {
      const module = viewData?.module || getViewModule(viewData);
      setActiveView(viewData);
      if (viewData?.id) {
        const { category, setState } = activeModuleDataMap?.[module] || {};
        if (category && setState) {
          setViewTypeLoading(true);
          getViewType(viewData?.id, category).then((res) => {
            if (
              res?.data?.getPersonalizationByCategoryAndName &&
              res?.data?.getPersonalizationByCategoryAndName?.value
            ) {
              const Value = JSON.parse(
                res?.data?.getPersonalizationByCategoryAndName.value
              );
              if (Value?.viewType) setState(Value?.viewType);
            } else {
              setState('list');
            }
            setViewTypeLoading(false);
          });
        }
      }
    }
  };

  const getModuleBasedOnPath = (pathname) => {
    // We can remove this function with Malathi's personalisation fixes
    if (pathname.includes('task-list')) {
      return 'TASK';
    }
    if (pathname.includes('project-list')) {
      return 'PROJECT';
    }
    return 'TICKET';
  };

  function getIntialViewState() {
    // We can remove this function with Malathi's personalisation fixes
    const currentView = props?.match?.params?.id || '1';
    const moduleData = getModuleBasedOnPath(location.pathname);
    setViewTypeLoading(true);
    const { category, setState } = activeModuleDataMap[moduleData];
    getViewType(currentView, category).then((res) => {
      if (
        res?.data?.getPersonalizationByCategoryAndName &&
        res?.data?.getPersonalizationByCategoryAndName?.value
      ) {
        const Value = JSON.parse(
          res?.data?.getPersonalizationByCategoryAndName.value
        );
        if (Value?.viewType) setState(Value?.viewType);
      } else {
        setState('list');
      }
      setViewTypeLoading(false);
    });
  }

  //TODO cleanup this logic
  if (
    userAppStateLoading ||
    (peronalizedData &&
      !userAppState &&
      peronalizedData.getPersonalizationByCategoryAndName)
  )
    return (
      <div className="vh100 flex center jctr">
        <AppLoader />
      </div>
    );

  if (userAppStateError) return <div />;
  const actions = {
    setActiveView: handleActiveViewChange,
    setActiveKanbanTab: setActiveKanbanTab,
    setPreviousView: setPreviousView,
    setPersonalization: setPersonalization,
    personalization: personalization,
    activeView: activeView,
    activeKanbanTab: activeKanbanTab,
    previousView: previousView,
    tabPersonalization: tabPersonalization,
    viewType,
    viewTypeLoading,
    setViewType: setViewTypeChange,
    taskViewType,
    setTaskViewType: setTaskViewTypeChange,
    projectViewType,
    setProjectViewType: setProjectViewTypeChange,
    records: records,
    setRecords: setRecords,
    setViewConditions: setViewConditionsCb,
    viewConditions: viewConditions,
    ticketOrProjectToInvoice,
    setTicketOrProjectToInvoice,
    productsToInvoice,
    getItemsToInvoice,
    getCustomerDetail,
    customerPaymentDetail
  };

  const updateUserAppState = (newAppState, cb) => {
    if (cb) {
      setUserAppState(newAppState, cb);
    } else {
      setUserAppState(newAppState);
    }
  };
  const updateSelectedModule = (newAppState) => {
    setSelectedModule(newAppState);
  };
  const switchTabFocus = (tab, newAppState = []) => {
    tabRef?.current?.switchActiveTab(tab, newAppState);
  };

  const openTab = (params) => {
    tabRef?.current?.openTabCb(params);
    closeHomeOverlay();
  };

  const closeCurrentTab = () => {
    const { activeTab } = tabRef?.current?.getCurrentState();
    tabRef?.current?.closeTabCb(activeTab);
  };

  const createTab = (params) => {
    const currentTabState = tabRef?.current?.getCurrentState();
    const currentState = currentTabState?.tabs
      ? cloneDeep(currentTabState.tabs)
      : [];
    const tab = {
      ...params,
      id: getTabId(params)
    };
    let dupTab = currentState.find((el) => el.id === tab.id);
    if (dupTab) {
      setUserAppState(
        {
          ...currentTabState,
          appState: currentState,
          activeTabIndex: currentState.findIndex((el) => el.id === tab.id)
        },
        () => {
          switchTabFocus(tab);
        }
      );
      closeHomeOverlay();
      return;
    }
    tab.content = getTabContent({ ...params, currentState, tab });
    // tab.component = getTabComponent({ ...params, currentState, tab });
    tab.displayData = getTabDisplayData(params);
    tab.data = params.data;
    if (flags?.urlRedirectionForTabs) {
      tab.url = getTabUrlNew(params);
    } else {
      tab.url = getTabUrl(params);
    }
    tab.module = params.module;
    currentState.push(tab);
    if (!currentTabState) {
      setUserAppState({ appState: currentState }, () => {
        switchTabFocus(tab);
      });
    } else {
      setUserAppState(
        {
          ...currentTabState,
          appState: currentState,
          activeTabIndex: currentState.findIndex((el) => el.id === tab.id)
        },
        () => {
          switchTabFocus(tab);
        }
      );
    }
    closeHomeOverlay();
  };

  const providerValue = {
    userAppState,
    updateUserAppState: updateUserAppState,
    toggleHomeOverlay,
    closeHomeOverlay,
    closeModulesOverlay,
    closeCreateNewOverlay,
    closeSettingsOverlay,
    switchTabFocus,
    openTab,
    closeCurrentTab,
    createTab,
    toggleCreateNewOverlay,
    toggleSettingsOverlay,
    toggleSpotlightOverlay,
    toggleModulesOverlay,
    selectedModule,
    updateSelectedModule,
    getBrowserType,
    settingsOverlay,
    user: appContext.user,
    getCustomerDetail,
    customerPaymentDetail
  };

  if (userAppState) {
    return (
      <HomeProvider value={providerValue}>
        <Frame
          navigation={
            <AppNavigation
              conf={envConfig}
              tabRef={tabRef}
              showQrMessage={showQrMessage}
            />
          }
        >
          <TabManager
            overlay={
              homeOverlay ||
              modulesOverlay ||
              createNewOverlay ||
              settingsOverlay
            }
            ref={tabRef}
            actions={actions}
          />
          {homeOverlay && (
            <Overlay>
              <HomePage />
            </Overlay>
          )}
          {modulesOverlay && (
            <Overlay className="sops-module-responsive">
              <ModulesPage />
            </Overlay>
          )}
          {createNewOverlay && (
            <Overlay className="sops-module-responsive sops-create-module">
              <GlobalCreatePage />
            </Overlay>
          )}
          {settingsOverlay && (
            <Overlay className="sops-module-responsive sops-settings-module">
              <SettingsPage />
            </Overlay>
          )}
          {spotlightOverlay && (
            <SpotlightPage
              tabRef={tabRef}
              setSpotlightOverlay={setSpotlightOverlay}
            />
          )}
        </Frame>
      </HomeProvider>
    );
  }
  if (props.match?.url === '/allmodules') {
    return (
      <HomeProvider value={providerValue}>
        <Frame
          navigation={
            <AppNavigation
              conf={envConfig}
              tabRef={tabRef}
              showQrMessage={showQrMessage}
            />
          }
        >
          <Overlay>
            <ModulesPage />
          </Overlay>
        </Frame>
      </HomeProvider>
    );
  }
  if (props.match?.url === '/createNew') {
    return (
      <HomeProvider value={providerValue}>
        <Frame
          navigation={
            <AppNavigation
              conf={envConfig}
              tabRef={tabRef}
              showQrMessage={showQrMessage}
            />
          }
        >
          <Overlay>
            <GlobalCreatePage />
          </Overlay>
        </Frame>
      </HomeProvider>
    );
  }
  if (props.match?.url !== '/home') {
    props.history.push('/home');
  }
  return (
    <HomeProvider value={providerValue}>
      <Frame
        navigation={
          <AppNavigation
            conf={envConfig}
            tabRef={tabRef}
            showQrMessage={showQrMessage}
          />
        }
      >
        <div>
          <HomePage />
        </div>
      </Frame>
    </HomeProvider>
  );
}

const Overlay = styled.div`
  position: absolute;
  top: 0;
  width: calc(100vw - 60px);
  z-index: 401 !important;
`;

export default withRouter(withLDConsumer()(AppHomePage));
